import { render, staticRenderFns } from "./editSocial.vue?vue&type=template&id=f21b4a74&scoped=true"
import script from "./editSocial.vue?vue&type=script&lang=js"
export * from "./editSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21b4a74",
  null
  
)

export default component.exports